__webpack_require__.p = "https://buyerwebui-prod-endpoint.azureedge.net/_next/";